import type { EntryNodeType } from '@/nodes/types';
import type { GuideNodeId } from '@rock/types';
import { DEFAULT_GUIDE_INTRO, outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';

const INTRO_LABELS = {
    space: 'space intro',
    generic: 'generic intro',
    skip: 'no intro',
} as const;

export const EntryNode: FC<NodeProps<EntryNodeType>> = ({ id, data }) => {
    const paths = outgoingHandles.entry(id as GuideNodeId, data);
    return (
        <div className="border-1 border-green-300 rounded-lg m-1 px-5 py-3 bg-green-100">
            <div className="text-md">Entry</div>
            <div className="text-xs text-gray-500">{INTRO_LABELS[data.intro ?? DEFAULT_GUIDE_INTRO]}</div>
            <Handle type="source" id={paths.next} position={Position.Right} />
        </div>
    );
};
